import { useEffect, useState } from "react";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { pushSupported, getPushSubscription, enablePush, disablePush } from "@/lib/push";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

export default function PushToggle() {
  const [state, setState] = useState("loading");
  useEffect(() => {
    if (!pushSupported()) { setState("unsupported"); return; }
    getPushSubscription().then((s) => setState(s ? "on" : "off")).catch(() => setState("off"));
  }, []);

  const toggle = async () => {
    const prev = state; setState("busy");
    try {
      if (prev === "on") { await disablePush(); setState("off"); toast.success("Phone notifications turned off"); }
      else { await enablePush(); setState("on"); await api.post("/push/test").catch(() => {}); toast.success("Notifications on — a test alert is on its way"); }
    } catch (err) { logError("Push toggle failed", err); toast.error(err.message || "Couldn't change notification settings"); setState(prev); }
  };

  if (state === "unsupported") return <p className="text-xs text-muted-foreground" data-testid="push-unsupported">Phone notifications need the installed app (Add to Home Screen) on this device.</p>;
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-border bg-card p-4" data-testid="push-toggle-card">
      <div className="flex items-start gap-3 min-w-0">
        {state === "on" ? <Bell className="w-5 h-5 text-accent shrink-0" /> : <BellOff className="w-5 h-5 text-muted-foreground shrink-0" />}
        <div>
          <p className="text-sm font-semibold">Phone & desktop notifications</p>
          <p className="text-xs text-muted-foreground">Inspection reminders, specialist replies and renewal alerts — even when the app is closed.</p>
        </div>
      </div>
      <Button size="sm" variant={state === "on" ? "outline" : "default"} onClick={toggle} disabled={state === "busy" || state === "loading"} data-testid="push-toggle-button">
        {state === "busy" || state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : state === "on" ? "Turn off" : "Turn on"}
      </Button>
    </div>
  );
}
